import { constants } from "../constants/redux-constants";



export const markTaskAsRead = (taskId) => ({
  type: constants.BACKGROUND_TASKS.MARK_AS_READ,
  payload: taskId,
});

export const markFailedTasksAsRead = () => ({
  type: constants.BACKGROUND_TASKS.MARK_FAILED_AS_READ,
});

export const removeActiveTasks = () => ({
  type: constants.BACKGROUND_TASKS.REMOVE_ACTIVE_TASKS,
});

export const set_show_task_inprogress_popup = (payload) => ({
  type: constants.BACKGROUND_TASKS.SHOW_TASK_INPROGRESS_POPUP,
  payload: payload,
});